import React, {FC} from 'react';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import {SetStatePropsType} from "@baseTypes/base";
import {SxType} from "@baseTypes/sx/sxTypes";


interface IProps {
    fullScreenMode: boolean,
    setFullScreenMode: SetStatePropsType<boolean>,
    sx?: SxType
    size?: 'small' | 'medium' | 'large'

}

const ToggleScreenModeButton: FC<IProps> = ({
                                                setFullScreenMode,
                                                fullScreenMode,
                                                sx,
                                                size='small',
                                            }) => {


    const handleScreenMode = () => {
        setFullScreenMode((prev) => !prev)
    }

    return (
        <IconButtonCustom
            sx={sx}
            size={size}
            onClick={handleScreenMode}
            variant={'empty'}
        >
            {fullScreenMode ?
                <CloseFullscreenIcon
                    fontSize={size}
                /> : <OpenInFullIcon
                    fontSize={size}
                />}
        </IconButtonCustom>
    );

};

export default ToggleScreenModeButton;